<template>
  <div/>
</template>

<script setup>
import { watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/authentication/user.store'

const userStore = useUserStore()
const { userId, domainInfo, isAuthenticated, fetching, userContentProfileId, isEnterprise, isPremium, isTrial, isLicenseExpired } = storeToRefs(userStore)

const activateAppcues = () => {
  if (!isAuthenticated.value || fetching.value) {
    return
  }
  
  if (!document.querySelector('#appcues-script-tag')) {
    window.AppcuesSettings = {
      enableURLDetection: true
    }
    let appcuesScript = document.createElement('script')
    appcuesScript.id = 'appcues-script-tag'
    appcuesScript.setAttribute('src', '//fast.appcues.com/128659.js')
    appcuesScript.onerror = () => {
      console.error('Failed to load Appcues script')
    }
    appcuesScript.onload = () => {
      Appcues.identify(userId.value, {
        domain_uuid: domainInfo.value?.uuid || '',
        domain_name: domainInfo.value?.name || '',
        isEnterprise: isEnterprise.value,
        isPremium: isPremium.value,
        isTrial: isTrial.value,
        isLicenseExpired: isLicenseExpired.value,
        userContentProfileId: userContentProfileId.value
      })
    }
    document.head.appendChild(appcuesScript)
  } else {
    if (typeof Appcues !== 'undefined') {
      Appcues.page(userId.value, {
        domain_uuid: domainInfo.value?.uuid || '',
        domain_name: domainInfo.value?.name || '',
        isEnterprise: isEnterprise.value,
        isPremium: isPremium.value,
        isTrial: isTrial.value,
        isLicenseExpired: isLicenseExpired.value,
        userContentProfileId: userContentProfileId.value
      })
    }
  }
}

watch([isAuthenticated, fetching], ([isAuth, isFetching]) => {
  if (isAuth && !isFetching) {
    activateAppcues()
  }
})

onMounted(() => {
  if (isAuthenticated.value && !fetching.value) {
    activateAppcues()
  }
})
</script>
